"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductExpirationIfAny = void 0;
const base_1 = require("../constants/base");
const getProductExpirationIfAny = (product) => {
    if (!product.hideLowExpiration) {
        if (product.customExpiration) {
            return product.customExpiration;
        }
        else if (product.expiration) {
            const today = new Date();
            const expireLimit = new Date(today);
            expireLimit.setMonth(today.getMonth() + base_1.EXPIRE_REDUCTION_MONTHS);
            if (new Date(product.expiration).getTime() < expireLimit.getTime()) {
                return product.expiration;
            }
        }
    }
};
exports.getProductExpirationIfAny = getProductExpirationIfAny;
